import { render, staticRenderFns } from "./UnqualifiedAdd.vue?vue&type=template&id=05716730&scoped=true&"
import script from "./UnqualifiedAdd.vue?vue&type=script&lang=js&"
export * from "./UnqualifiedAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05716730",
  null
  
)

export default component.exports